/* Third-party "Fast Simon" search/autocomplete app: it hijacks our own theme search form (adds
   its own "fast-simon-form" marker class directly onto sections/header.liquid's .so-form) and
   renders its own autocomplete dropdown (.fast-simon-autocomplete) -- confirmed via live
   inspection that dropdown was popping a stray "No results for..." card on top of / behind our
   own correct predictive-search results.

   Confirmed the dropdown element's parentNode is a ShadowRoot (nodeType 11, "#document-fragment"),
   not a normal element -- i.e. it's rendered inside a Shadow DOM tree the app attaches somewhere
   on the page. Shadow DOM is deliberately encapsulated: NO page-level CSS rule, no matter how
   specific or how many !important flags, can style something inside another script's shadow
   root from outside. That's why a CSS-only attempt at this (previously in assets/base.css) had
   no effect despite the element clearly matching the selector.

   The only thing that CAN reach in is JS running in the page, manipulating that exact element's
   own inline style directly (confirmed live: el.style.setProperty('display','none','important')
   on the found element hides it immediately). Since Fast Simon creates/destroys this dropdown
   dynamically as the shopper types, this uses a MutationObserver on the whole document (which
   still notifies about the light-DOM elements Fast Simon adds, even though it can't see inside
   an already-open shadow root by itself) plus a recursive shadow-root walk on every mutation to
   find and hide the dropdown wherever it currently lives.

   This only hides the widget's own UI -- it doesn't touch the app or its script (loaded from
   fastsimon.com / akamaized.net, not part of this theme) in any other way. A full removal would
   need to happen in the Fast Simon app's own settings, or by uninstalling it from Shopify admin
   > Settings > Apps. */
(function(){
  function hideEl(el){
    if(el && el.style){ el.style.setProperty('display','none','important'); }
  }
  function scan(root){
    if(!root || !root.querySelectorAll) return;
    root.querySelectorAll('.fast-simon-autocomplete').forEach(hideEl);
    root.querySelectorAll('*').forEach(function(el){
      if(el.shadowRoot) scan(el.shadowRoot);
    });
  }
  scan(document);
  var mo = new MutationObserver(function(){ scan(document); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
